import styled from '@emotion/styled'
import { MediaQuery } from '../hooks'

export const PharmacSearchWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  ${MediaQuery.maxTablet} {
    justify-content: flex-start;
  }
`
